import React from 'react';
import { useNavigate } from 'react-router-dom';

import { InfoCard, InfoCardVariants } from '@backstage/core-components';

import { Box, Typography } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles((_theme: Theme) =>
  createStyles({
    tutorialLink: {
      cursor: 'pointer',
      textDecoration: 'underline',
    },
  }),
);

const CardTitle = (props: { title: string }) => (
  <Box display="flex" alignItems="center">
    <InfoIcon fontSize="inherit" />
    <Box ml={1}>{props.title}</Box>
  </Box>
);

type Props = {
  variant?: InfoCardVariants;
};

export const EntityGroupInfoPromptCard = (props: Props) => {
  const { variant } = props;
  const classes = useStyles();

  const navigate = useNavigate();
  // The routeRef for this is not exposed, sadly
  const handlePromptClick = () =>
    navigate({ pathname: '/create/templates/team-info' });

  return (
    <InfoCard title={<CardTitle title="Info Missing" />} variant={variant}>
      <Typography variant="body1" component="p" display="inline">
        This Team is missing some details!&nbsp;
      </Typography>
      <Typography
        variant="body1"
        component="p"
        display="inline"
        className={classes.tutorialLink}
        onClick={handlePromptClick}
      >
        Add them here
      </Typography>
    </InfoCard>
  );
};
